export default {
  coupon: {
    selectCoupons: 'Sélectionner les coupons',
    tips: 'Recommandé <span class="orange-text">{x} coupon(s)</span> sélectionné, sauver <span class="orange-text">{y}</span>',
    couponTips: '<span class="orange-text">{x} coupon(s)</span> sélectionné, sauver <span class="orange-text">{y}</span>',
    noSelectedTips: '<span class="orange-text">{x} Coupon(s)</span> Disponible',
    changeCard: 'Changer de carte de paiement',
    automaticPay: 'Paiement automatique',
    authorized: 'Autorisé',
    unauthorized: 'Non autorisé',
  },
  automaticPay: {
    queryRecords: 'Historique de fermeture des requêtes',
    actionTime: "Heure de l'opération",
    actionType: "Type d'opération",
    actionResult: "Résultat de l'opération",
    resultDesc: 'Description du résultat',
    activate: 'Activation',
    approved: 'Approuvé',
    rejected: 'Rejeté',
    underReview: "En cours d'examen",
    autoDeductClose: 'Voulez-vous désactiver le prélèvement automatique ?',
    confirmSubmitClose: 'Veuillez confirmer si vous avez soumis une demande pour désactiver le prélèvement automatique.',
    closeNotice: 'Une fois la demande approuvée, le système ne déduira plus les paiements automatiquement. Si la date limite de paiement est dépassée, le système procédera à votre désinscription automatique du cours.',
    cancelReasonPrompt: 'Veuillez sélectionner une raison d’annulation :',
    reasonPrompt: 'Sélectionnez une raison',
    otherReason: 'Autres',
    closeReasonInput: 'Veuillez indiquer la raison de la désactivation du prélèvement automatique.',
    installmentPlan: 'Plan de paiement en plusieurs fois',
    requestSubmitted: 'Votre demande de désactivation du prélèvement automatique a été soumise.',
    underReviewNotice: "Vous avez une demande en cours d'examen, veuillez ne pas soumettre de doublons.",
    viewReviewResult: ["Vous pouvez consulter le résultat de l'examen dans ", '.'],
    autoApproved: 'Approuvé automatiquement',
    turnOffAutoDebit: 'Voulez-vous désactiver le prélèvement automatique ?',
  },
}
